import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    formContainer: {
      boxSizing: 'border-box',
      paddingLeft: 32,
      marginBottom: 24,
    },
    error: {
      color: palette.red,
      marginTop: 6,
      marginBottom: 8,
      marginLeft: 12,
    },

    iconYellow: {
      color: palette.navCompanyContextActions,
      fontSize: 22,
    },
    iconGreen: {
      color: palette.navAdmin,
      fontSize: 22,
    },
    iconGray: {
      color: palette.navSuperAdminActions,
      fontSize: 22,
    },
    iconBlue: {
      color: palette.navOperator,
      fontSize: 22,
    },

    datePickerContainer: {
      width: '100%',
    },
    weekDays: {
      display: 'contents',
      justifyContent: 'space-between',
      overflow: 'auto',
    },
    day: {
      width: 22,
      height: 26,
      fontSize: 15,
      padding: '0px 2px',
      color: palette.gray,
      background: `rgba(238, 204, 51, .1)`,
      border: `1px solid ${palette.primary.main}`,
      cursor: 'pointer',

      '&:hover': {
        background: `rgba(238, 204, 51, .3)`,
      },
    },
    daySelected: {
      backgroundColor: palette.primary.main,
      fontWeight: typography.fontWeightMedium,
    },
    periodText: {
      fontSize: 12,
      padding: '6px 12px',
      fontWeight: 500,
    },
  });
